import { render, staticRenderFns } from "./refOrgPropertiesList.vue?vue&type=template&id=3ae66337"
import script from "./refOrgPropertiesList.vue?vue&type=script&lang=js"
export * from "./refOrgPropertiesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports